export function getValueKey(value) {
    if (value === undefined) {
        return 'undefined';
    }
    switch (typeof value) {
        case 'number':
        case 'string':
            return 'constant:' + value;
        default:
            return 'json:' + JSON.stringify(value);
    }
}
